/**
 * @enum {string}
 * @readonly
 */
export const TextMessage = Object.freeze({
    ACKNOWLEDGE_TIME: 'acknowledgeTime',
    ADDRESS_ID: 'addressId',
    CREATION_TIME: 'creationTime',
    DISCARDED_TIME: 'discardedTime',
    LAST_MODIFIED_TIME: 'lastModifiedTime',
    LOCATION_DESCRIPTION: 'locationDescription',
    ODOMETER: 'odometer',
    ORDER_ID: 'orderId',
    POSITION: 'position',
    POSITION_TIME: 'positionTime',
    READ_TIME: 'readTime',
    RECEIVER: 'receiver',
    SENDER: 'sender',
    SPEED: 'speed',
    STATUS: 'status',
    STATUS_TEXT: 'statusText',
    TEXT: 'text',
    TEXT_MESSAGE_ID: 'textMessageId',
    TRIP_MODE: 'tripMode',
    TYPE: 'type',
    USER_ID: 'userId'
})
